import { ExpectedQueryData } from 'components/table/hooks/useServerFilteredTable';
import { getPaginationParams } from 'components/table/utils/pagination';
import {
  GetSeasonalRulesResponse,
  SeasonalRule,
} from 'models/seasonality/SeasonalRule';
import API from 'services/API';

export interface FetchSeasonalRulesArgs {
  pageIndex: number;
  pageSize: number;
}

export const fetchSeasonalRules = async ({
  pageIndex,
  pageSize,
}: FetchSeasonalRulesArgs): Promise<ExpectedQueryData<SeasonalRule>> => {
  const response = await API.get<GetSeasonalRulesResponse>(
    '/api/internal/seasonal-rules/cancellation-policies',
    {
      params: getPaginationParams({ pageIndex, pageSize }),
    },
  );

  return {
    _metadata: response.data._metadata,
    data: response.data.items,
  };
};
